const config = {
  baseUrl: process.env.VUE_APP_LOCATION,
  contextPath: process.env.VUE_APP_LOCATION + process.env.VUE_APP_CONTEXT_PATH
}

export default config
